module.exports = __webpack_public_path__ + "media/images/about---cb2a9c72400bab7310da107b47849a0f.jpg";